var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderEmptyGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.07 122.32H18L31.07 58.5901C31.337 57.0849 32.1159 55.7182 33.2749 54.7214C34.4339 53.7246 35.9018 53.1589 37.43 53.1201H132.79C133.598 53.1551 134.389 53.3686 135.104 53.7453C135.82 54.122 136.444 54.6525 136.931 55.2987C137.417 55.9449 137.755 56.6909 137.919 57.483C138.083 58.2751 138.07 59.0937 137.88 59.8801L125.07 122.32Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 122.32V27.6799H48.3L54.16 37.9399H118.16C119.388 37.9399 120.566 38.4277 121.434 39.296C122.302 40.1643 122.79 41.342 122.79 42.5699V49.3199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderEmptyGrey);
export default __webpack_public_path__ + "static/media/folder_empty_grey.736176f1240d3dda2c00ca525d21b9a2.svg";
export { ForwardRef as ReactComponent };